import ajax from './axios'

export const getfilter = (params) => {
    return ajax.get('/api/v2/hotkeyword/fund/filter?fund_type=' + params.fund + '&category=' + params.cat + '&foundation=' + params.foundation + '&read_more=' + params.readmore, )
}

export const getfund = (params) => {
    return ajax.get('/api/v2/hotkeyword/fund')
}

export const getchart = (params) => {
    return ajax.get('/api/v2/hotkeyword/fund/chart?fund_type=' + params.fund + '&category=' + params.category + '&keyword=' + params.keyword + '&venue_type=' + params.type + '&foundation=' + params.foundation)
}

export const getwordcloud = (params) => {
    return ajax.get('/api/v2/hotkeyword/fund/word_cloud/chart?fund_type=' + params.fund + '&category=' + params.cat + '&keyword=' + params.keyword + '&foundation=' + params.foundation)
}

export const getRelatedSentence = (params) => {
    return ajax.get('/api/v2/hotkeyword/fund/word_cloud/summarize?keyword=' + params.keyword + '&sequence=' + params.sequence)
}

export const getauthor = (params) => {
    return ajax.get('/api/v2/hotkeyword/category/unit_author?category=' + params.category + '&keyword=' + params.keyword + '&count=' + params.count + '&foundation=' + params.foundation)
}

export const giveFeedback = (params) => {
    return ajax.post('/api/v2/hotkeyword/fund/word_cloud/summarize/evaluate', params)
}
export const getSearchResult = (params) => {
    return ajax.get('/api/v2/hotkeyword/generated_text?query=' + params.query + '&keyword=' + params.keyword)
}


// WEBPACK FOOTER //
// ./src/api/hotkeyword2.js